/**
 * This is the entry point for specific javascript of theme
 */
import './infinite-scroll.js';
import './read-more.js';

console.log('niu Theme')

/**
 * Traduzione label attributi prodotto (Taglia, Colore, ecc.)
 * Sostituisce le label italiane con le traduzioni in base alla lingua della pagina.
 * Utile per store multi-lingua senza accesso al backoffice.
 */
void (function translateProductOptionLabels() {
  const lang = document.documentElement.lang;

  // Solo se la lingua non è italiano
  if (!lang || lang === 'it') return;

  // Solo se siamo in una pagina prodotto
  const body = document.body;
  if (!body.classList.contains('template-product')) return;

  const translations = {
    en: {
      'Taglia': 'Size',
      'Colore': 'Color',
    },
    fr: {
      'Taglia': 'Taille',
      'Colore': 'Couleur',
    },
    de: {
      'Taglia': 'Größe',
      'Colore': 'Farbe',
    },
    es: {
      'Taglia': 'Talla',
      'Colore': 'Color',
    },
  };

  const map = translations[lang];
  if (!map) return;

  function applyTranslations() {
    document.querySelectorAll('.option-selector').forEach((fieldset) => {
      const optionName = fieldset.dataset.option; // es. "Taglia" o "Colore"
      if (!optionName || !map[optionName]) return;

      const legend = fieldset.querySelector('legend.label');
      if (!legend) return;

      // Sostituisce solo il primo nodo di testo, preservando eventuali <span> figli
      for (const node of legend.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
          // Preserva l'eventuale suffisso ": " dopo la label
          const hasSuffix = node.textContent.includes(': ');
          node.textContent = map[optionName] + (hasSuffix ? ': ' : '\n              ');
          break;
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      applyTranslations();
      observeMutations();
    });
  } else {
    applyTranslations();
    observeMutations();
  }

  function observeMutations() {
    // Osserva il contenitore del form prodotto per riapplicare le traduzioni
    // quando Shopify ri-renderizza i selettori al cambio variante
    const target = document.querySelector('.product-form, #product-form, [data-section-type="product"], main') || document.body;
    const observer = new MutationObserver(() => {
      applyTranslations();
    });
    observer.observe(target, { childList: true, subtree: true });
  }
}());

